import { get, filter, merge } from 'lodash';
import * as actions from '../actions/report-builder-actions';
import {
  parseViewData,
  constructView,
  buildReportFromData
} from '../utils/report-builder';

const initialState = {
  uuid: '',
  name: '',
  userId: '',

  views: {},
  loading: false,
  error: false,
  requestUUID: '',
  ignoreCustomViewRequest: [],

  query: {},
  state: {},
  data: [],
  myReports: [],
  savedReport: {}
};

export default function reportBuilder(state = initialState, action = {}) {
  switch (action.type) {
    case actions.REPORT_RESET: {
      return { ...initialState, views: state.views };
    }

    case actions.REPORT_UPDATE_STATE: {
      return {
        ...state,
        state: action.state
      };
    }

    case actions.REPORT_CHANGE_DATA: {
      return {
        ...state,
        data: action.data
      };
    }

    case actions.REPORT_VIEWS_REQUEST:
    case actions.REPORT_LIST_REQUEST:
    case actions.REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false
      };

    case actions.REPORT_VIEWS_ERROR:
    case actions.REPORT_LIST_ERROR:
    case actions.REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case actions.REPORT_VIEWS_SUCCESS: {
      const availableFilters = get(action, 'availableFilters', {});
      const data = get(action, 'data', []);
      const views = constructView(data);

      return {
        ...state,
        views: merge(views, availableFilters),
        loading: false
      };
    }

    case actions.REPORT_VIEW_REQUEST: {
      const { requestUUID, specs } = action;
      return {
        ...state,
        requestUUID,
        query: { ...specs },
        loading: true,
        error: false
      };
    }

    case actions.REPORT_VIEW_SUCCESS: {
      if (state.ignoreCustomViewRequest.includes(action.requestUUID)) {
        return {
          ...state,
          ignoreCustomViewRequest: filter(
            state.ignoreCustomViewRequest,
            requestUUID => requestUUID === action.requestUUID
          )
        };
      }

      const rawData = get(action, ['result', 'data'], []);
      return {
        ...state,
        data: parseViewData(rawData),
        loading: false
      };
    }

    case actions.REPORT_VIEW_ERROR: {
      if (state.ignoreCustomViewRequest.includes(action.requestUUID)) {
        return {
          ...state,
          ignoreCustomViewRequest: filter(
            state.ignoreCustomViewRequest,
            requestUUID => requestUUID === action.requestUUID
          )
        };
      }

      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    case actions.REPORT_VIEW_IGNORE:
      return {
        ...state,
        loading: false,
        ignoreCustomViewRequest: [
          ...state.ignoreCustomViewRequest,
          state.requestUUID
        ]
      };

    case actions.REPORT_LIST_SUCCESS: {
      const myReports = get(action, 'data', []);
      return {
        ...state,
        loading: false,
        myReports
      };
    }

    case actions.REPORT_SUCCESS: {
      const { name, uuid, userId } = action.data;
      const newState = buildReportFromData(state, action.data);
      return {
        ...state,
        loading: false,
        uuid,
        name,
        userId,
        savedReport: newState
      };
    }

    default:
      return state;
  }
}

export const selectUserId = state =>
  get(state, ['reportBuilder', 'userId'], []);
export const selectName = state => get(state, ['reportBuilder', 'name'], '');
export const selectViews = state => get(state, ['reportBuilder', 'views'], {});
export const selectData = state => get(state, ['reportBuilder', 'data'], []);
export const selectLoading = state =>
  get(state, ['reportBuilder', 'loading'], false);
export const selectError = state =>
  get(state, ['reportBuilder', 'error'], false);
export const selectIgnoreCustomViewRequest = state =>
  get(state, ['reportBuilder', 'ignoreCustomViewRequest'], []);
export const selectState = state => get(state, ['reportBuilder', 'state'], {});
export const selectMyReports = state =>
  get(state, ['reportBuilder', 'myReports'], []);
